import { Injectable, Inject } from '@angular/core';
import { IImmunotherapyFinding } from '../interfaces/immunotherapy-finding.interface';
import { FindingsActionCreatorService } from './findings-action-creator.service';
import { Observable } from 'rxjs';
import { WorkflowConfigService } from '../../../../../workflow-config/services/workflow-config.service';
import { finalize, flatMap, map, publish } from 'rxjs/operators';
import { ResourceRestService } from '../../../../../workflow-config/services/resource-rest.service';
import { Resources } from '../../../../../../app/workflow-config/constants/resources.enum';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Injectable()
export class MolecularFindingService {
  static readonly baseUri: string = '/molecularFinding';
  private ongoingReq;

  constructor(
    private _http: ResourceRestService,
    private findingsAC: FindingsActionCreatorService,
    private workflowConfig: WorkflowConfigService,
    private notificationMessageService: NotificationMessageService
  ) {
  }

  /**
   * Updating the molecular finding
   * @param {IImmunotherapyFinding} updateData
   * @param {String} testType
   * @param {Boolean} silent
   * @returns {Observable<any>}
   */
  update(updateData: IImmunotherapyFinding, testType: string, silent = false) {
    return this._http.put(MolecularFindingService.baseUri + '/update', {
      data: updateData,
      revisionId: ResourceRestService.getResourcesString(Resources.MolecularFinding, Resources.FirstRevision),
      activeRevisionId: ResourceRestService.getResourcesString(Resources.ActiveRevision),
      currentRevisionId: ResourceRestService.getResourcesString(Resources.RequestedRevision),
      workflowId: ResourceRestService.getResourcesString(Resources.WorkflowRequest),
      testType
    }, !silent)
      .map(res => res.json())
      .map(res => {
        if (!silent) {
          this.notificationMessageService.success('Molecular finding updated');
        }

        this.findingsAC.update('molecularFinding', res);

        return res;
      })
      .catch(err => {
        if (!silent) {
          this.notificationMessageService.error(err.error || 'unable to update molecular finding');
        }

        return err;
      });
  }


  /**
   * get the molecular finding element and store it
   */
  get(): Observable<IImmunotherapyFinding> {
    return this.findingsAC.getState('molecularFinding')
      .flatMap((res: any) => {
        if (res === null || (typeof res === 'object' && Object.keys(res).length === 0)) {
          this.getMolecularFindingFromServer();
        }

        return Observable.of(<IImmunotherapyFinding> res);
      });
  }

  public getMolecularFindingFromServer() {
    this.ongoingReq =
      this.workflowConfig
        .interpolateWithResourcesMap(
          `${MolecularFindingService.baseUri}/getByRevision/$(${Resources.MolecularFinding})`,
          { [Resources.MolecularFinding]: 'firstRevision'}
        )
        .pipe(
          flatMap((requestUrl) => this._http.get(requestUrl)),
          map(res => res.json()),
          map((res) => {
            this.findingsAC.update('molecularFinding', res);
            return res;
          }),
          finalize(() => {
            this.ongoingReq = null;
          }),
          publish()
        );
      this.ongoingReq.connect();

    return this.ongoingReq;
  }
}
